export default __webpack_public_path__ + "media/slide-3.5f47a9f4.png";